const MoreVerticalIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="5" r="1.5" fill="#9CA3AF"/>
    <circle cx="12" cy="12" r="1.5" fill="#9CA3AF"/>
    <circle cx="12" cy="19" r="1.5" fill="#9CA3AF"/>
  </svg>
)

export default MoreVerticalIcon
